import i18n from "../i18n";

export const convertUnicode = (input) => {
  return input.replace(/\\u(\w{4,4})/g,(a,b) => {
    var charcode = parseInt(b,16);
    return String.fromCharCode(charcode);
  });
};

export const transCodes = (t, tag) => {
  const tagVal = t(tag);
  const val = tagVal !== undefined ? tagVal : i18n.t(tag);
  return convertUnicode(val);
};

export const getCurrentLng = () => i18n.language || window.localStorage.i18nextLng || "";

export const getLocale = () => {
  if (window.env && window.env.locale_codes) {
    try {
      const localeCodes = JSON.parse(window.env.locale_codes);
      const locale = localeCodes[getCurrentLng()];
      if (locale) return locale;
    } catch (error) {
      /* ignore */
    }
  }
  return "en-US";
};
